import Swal from "sweetalert2";
import { postRequestByAuth } from "../../../../../function/helper";
import getSenderAddress from "../../../../shop/components/Shipments/functions/getSenderAddress";
import getCompany from "../../../../shop/components/Shipments/functions/getCompany";

const avaBoxSubmit = async ({
  shipments,
  setPrices,
  setLoading,
  needPrint,
  needSMS,
}) => {
  const senderAddress = getSenderAddress();
  const selectedCompany = getCompany();

  if (senderAddress === undefined) {
    Swal.fire({
      icon: "error",
      confirmButtonText: "متوجه شدم",
      confirmButtonColor: "gray",
      text: "آدرس فرستنده (مبدا) مشخص نشده است",
    });

    return;
  }

  if (selectedCompany.value === -1) {
    Swal.fire({
      icon: "error",
      confirmButtonText: "متوجه شدم",
      confirmButtonColor: "gray",
      text: "نوع سرویس دهنده را انتخاب نکردید",
    });

    return;
  }

  setLoading(true);
  const response = await postRequestByAuth("/internalpost/v1/avaBoxRate", {
    senderAddressId: senderAddress.id,
    shipments,
    needPrint,
    needSMS,
    company: {
      componyTypeId: selectedCompany.selected.componyTypeId,
      componyId: selectedCompany.selected.componyId,
    },
    isCod: selectedCompany.selected.isCod,
  });
  setLoading(false);

  if (response.status === 200) {
    setPrices(() => response.data.result);
  } else {
    if (response.data?.message) {
      Swal.fire({
        icon: "error",
        text: response.data.message,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "gray",
      });
    }
    setPrices(() => shipments.map(item => ({ ui: item.ui, price: 0 })));
  }
};

export default avaBoxSubmit;
